import cx from 'classix';
import Image from 'next/image';

import styles from './avatar.module.scss';

interface AvatarProps {
  imageSrc: string;
  alt: string;
  fill?: boolean;
  size?: number;
  view?: 'circle' | 'square';
  quality?: number;
}

export default function Avatar(props: AvatarProps) {
  const {
    alt,
    fill,
    imageSrc,
    quality = 30,
    size = 40,
    view = 'circle',
  } = props;

  return (
    <Image
      className={cx(styles.avatar, view === 'square' && styles.avatar__isSquare)}
      src={imageSrc}
      alt={alt}
      width={fill ? undefined : size}
      height={fill ? undefined : size}
      fill={fill}
      quality={quality}
    />
  );
}
